import request from './request'

export function zhbList(data) {
    return request({
      url: '/index.php/end_of_life_vehicles/zhbList',
      method: 'post',
      data
    })
  }
export function zhbAdd(data) {
    return request({
      url: '/index.php/end_of_life_vehicles/zhbAdd',
      method: 'post',
      data
    })
}
export function zhbIdentify(data) {
    return request({
      url: '/index.php/end_of_life_vehicles/zhbIdentify',
      method: 'post',
      data
    })
}
export function getZhbInfo(data) {
    return request({
      url: '/index.php/end_of_life_vehicles/getZhbInfo',
      method: 'post',
      data
    })
}